import { NumberInput } from '@angular/cdk/coercion';
import { Component, computed, input, numberAttribute } from '@angular/core';
import { Badge } from '../badge/badge.component';

@Component({
  selector: 'procure-survey-score',
  templateUrl: './survey-score.component.html',
  imports: [Badge],
})
export class SurveyScore {
  readonly score = input.required<number, NumberInput>({
    transform: numberAttribute,
  });

  readonly suffix = input<string>();

  readonly label = computed(() =>
    Number.isNaN(this.score())
      ? 'n/a'
      : `${this.score()}${this.suffix() ? this.suffix() : ''}`,
  );

  readonly backgroundColor = computed(() => {
    const score = this.score();

    if (score >= 0 && score < 40) {
      return '#ff000f';
    }

    if (score >= 40 && score < 80) {
      return '#ff6c25';
    }

    if (score >= 80 && score < 100) {
      return '#00b102';
    }

    return '#007a33';
  });
}
